import React from 'react';
import useChoice from '../../../../react-hooks/useChoice';

const ChoiceLabel = ({ set, value }) => {
    const label = useChoice({ type: set, value });
    return <span>{label}</span>;
};

export default ChoiceLabel;
